export default {
    nav: {
        home: 'Home',
        products: 'Prodotti',
        solutions: 'Soluzioni',
        support: 'Supporto',
        aboutUs: 'Chi siamo',
        contact: 'Contattaci'
    },
    hero: {
        title: 'Kooyii Smart<br>Soluzioni complete per spazi intelligenti e allarmi di sicurezza',
        desc: 'Rendere gli spazi più intelligenti, più sicuri e più protetti.'
    },
    protocol: {
        title: 'Protocolli di comunicazione',
        cards: {
            zigbee: 'Zigbee 3.0 è uno standard di comunicazione wireless unificato introdotto dalla Connectivity Standards Alliance (CSA), che consente un\'interoperabilità fluida tra marchi e reti mesh a basso consumo integrando protocolli applicativi frammentati.',
            wifi: 'Il Wi-Fi è una tecnologia di rete wireless riconosciuta a livello mondiale che trasmette dati tramite onde radio, consentendo ai dispositivi di connettersi alle reti senza cavi fisici.',
            rf433: '433MHz è una banda radio a bassa frequenza comunemente utilizzata per dispositivi a corto raggio e a basso consumo, come sistemi di allarme di sicurezza e interruttori intelligenti.',
            modbus: 'Modbus è un protocollo di comunicazione seriale ampiamente utilizzato nell\'automazione industriale, che supporta la comunicazione master-slave e lo scambio di dati.',
            knx: 'KNX è una tecnologia bus standard europea ampiamente utilizzata nei sistemi di automazione per edifici intelligenti.',
            bluetooth: 'Il Bluetooth è una tecnologia wireless per la comunicazione tra dispositivi, ampiamente utilizzata in hotel intelligenti, smart home e altri settori.'
        }
    },
    services: {
        title: 'Scenari applicativi',
        features: {
            smartHome: {
                title: 'Casa Intelligente',
                desc: 'Rompi i limiti delle case tradizionali per creare uno spazio abitativo intelligente per tutti gli scenari. Supportando protocolli multipli come Zigbee e Wi-Fi, consente l\'interconnessione dei dispositivi e il cambio di scena senza interruzioni. Sblocca uno stile di vita altamente efficiente e conveniente con operazioni minimaliste, portando il calore della tecnologia nella tua esperienza abitativa.'
            },
            security: {
                title: 'Sicurezza Intelligente',
                desc: 'Un host di allarme di sicurezza abbinato a una piattaforma di monitoraggio professionale per costruire un sistema di sicurezza integrato. Come nucleo del sistema, l\'host si connette a vari rilevatori (infrarossi, fumo, pulsanti di emergenza) tramite il protocollo 433MHz, consentendo avvisi in tempo reale per intrusioni, incendi ed emergenze.'
            },
            hotel: {
                title: 'Hotel Intelligente',
                desc: 'Incentrata sull\'IoT e abbinata a una piattaforma di gestione delle apparecchiature alberghiere, questa soluzione collega camere intelligenti, operazioni di reception e servizi in camera, offrendo un doppio valore sia agli ospiti che alla direzione dell\'hotel.'
            },
            building: {
                title: 'Automazione degli Edifici',
                desc: 'Basato su RTU e configurato tramite un backend di gestione, supporta l\'integrazione dei dispositivi Modbus per ottenere facilmente monitoraggio centralizzato, controllo intelligente e gestione energetica delle apparecchiature dell\'edificio, trasformando gli edifici tradizionali in edifici intelligenti.'
            }
        }
    },
    software: {
        title: 'Software e Piattaforme',
        steps: {
            cms: { title: 'Centro Ricezione Allarmi', desc: 'Fai clic per visitare' },
            kooyii: { title: 'Kooyii', desc: 'Passa il mouse per scansionare e scaricare' },
            elderly: { title: 'Assistenza Anziani Intelligente', desc: 'Esperienza non ancora disponibile. Contatta le vendite per i dettagli.' },
            hotel: { title: 'Hotel Intelligente', desc: 'Esperienza non ancora disponibile. Contatta le vendite per i dettagli.' },
            building: { title: 'Automazione degli Edifici', desc: 'Esperienza non ancora disponibile. Contatta le vendite per i dettagli.' },
            more: { title: 'Altri Scenari', desc: 'Contatta le nostre vendite per una consulenza professionale.' }
        }
    },
    solutions: {
        services: {
            title: 'I Nostri Servizi',
            features: {
                hardware: {
                    title: 'Personalizzazione Hardware',
                    desc: 'Servizi esclusivi di progettazione e produzione end-to-end, dalle schede PCBA principali all\'estetica completa del dispositivo. Copre la progettazione dei circuiti, la selezione dei componenti, il layout PCB, il debug funzionale, gli stampi dell\'involucro, i materiali e la protezione strutturale.'
                },
                software: {
                    title: 'Personalizzazione Software',
                    desc: 'Sviluppo di app su misura e sistemi web basati sulle tue effettive esigenze aziendali, incluse app mobili (iOS/Android), pagine web per PC e gestione del backend. Fornisce una soluzione digitale altamente efficiente e su misura per il tuo modello operativo.'
                },
                server: {
                    title: 'Distribuzione Privata',
                    desc: 'Distribuisci sistemi, piattaforme o applicazioni interamente sui tuoi server o in ambienti intranet designati. I dati e i servizi funzionano in modo completamente indipendente, ottenendo un controllo autonomo totale.'
                }
            }
        },
        whyUs: {
            title: 'Perché Sceglierci?',
            benefits: {
                oneStop: {
                    title: 'Servizio Tutto in Uno',
                    desc: 'Le nostre soluzioni coprono sia il software che l\'hardware con un allineamento end-to-end unificato, eliminando il coordinamento tra più parti, accorciando i cicli di sviluppo e riducendo i costi di comunicazione.'
                },
                custom: {
                    title: 'Personalizzazione Profonda',
                    desc: 'Le funzionalità del software sono abbinate in modo preciso alle prestazioni dell\'hardware, evitando problemi di compatibilità e garantendo un funzionamento generale più fluido con tassi di guasto inferiori.'
                },
                expandable: {
                    title: 'Alta Scalabilità',
                    desc: 'I nostri servizi riservano interfacce di espansione, facilitando l\'aggiornamento e l\'espansione delle funzionalità da parte dei clienti in base alle esigenze future.'
                },
                deployment: {
                    title: 'Distribuzione Flessibile',
                    desc: 'Che si tratti di una distribuzione privata localizzata o di una distribuzione su cloud pubblico, forniamo soluzioni flessibili per soddisfare le tue esigenze.'
                }
            }
        },
        cta: {
            title: 'Pronto a migliorare il tuo stile di vita?',
            desc: 'Parla oggi stesso con i nostri esperti di smart home e lasciaci progettare l\'ecosistema perfetto per te.',
            button: 'Contatta le Vendite'
        }
    },
    product: {
        nav: {
            panel: 'Pannelli di Controllo',
            hub: 'Hub Intelligenti',
            switch: 'Interruttori Intelligenti',
            curtain: 'Tende Intelligenti',
            sensor: 'Sensori',
            lighting: 'Illuminazione Intelligente',
            security: 'Sicurezza Intelligente',
            doorlock: 'Serrature Intelligenti'
        },
        sub: {
            '4inch': '4 Pollici',
            '5inch': '5 Pollici',
            '6inch': '6 Pollici',
            '7inch': '7 Pollici',
            '8inch': '8 Pollici',
            '10inch': '10 Pollici',
            '1gang': '1 Canale',
            '2gang': '2 Canali',
            '3gang': '3 Canali',
            '4gang': '4 Canali',
            'openclose': 'Motore per Tende',
            'roller': 'Tenda a Rullo',
            'downlight': 'Faretti e Downlight',
            'magnetic': 'Luci a Binario Magnetico',
            'strip': 'Strisce LED',
            'alarm': 'Host di Allarme',
            'door': 'Sensore Porta/Finestra',
            'smoke': 'Rilevatore di Fumo',
            'infrared': 'Rilevatore a Infrarossi',
            'radar': 'Radar di Presenza Umana',
            'water': 'Sensore di Perdita d\'Acqua',
            'temp': 'Sensore di Temp. e Umidità',
            'indoorCam': 'Telecamera Interna',
            'outdoorCam': 'Telecamera Esterna',
            'password': 'Serratura con Password',
            'fingerprint': 'Serratura con Impronta Digitale',
            'face': 'Serratura con Riconoscimento Facciale'
        },
        common: {
            learnMore: 'Scopri di più',
            addToCart: 'Aggiungi al carrello',
            buyNow: 'Acquista ora',
            emptyProduct: 'Nessun prodotto correlato al momento. Resta sintonizzato...'
        },
        cart: {
            titleList: 'Lista delle Richieste',
            titleForm: 'Compila le Informazioni di Contatto',
            empty: 'La tua lista è vuota, vai ad aggiungere qualche prodotto!',
            delete: 'Elimina',
            totalItems: 'Totale di {count} prodotti selezionati',
            nextStep: 'Passaggio Successivo: Compila le Informazioni',
            submit: 'Invia Richiesta'
        },
        form: {
            name: 'Come dovremmo chiamarti?',
            namePlaceholder: 'Inserisci il tuo nome',
            address: 'Indirizzo Aziendale',
            addressPlaceholder: 'Inserisci l\'indirizzo dettagliato della tua azienda',
            location: 'Città / Paese',
            locationPlaceholder: 'Es. Roma, Italia',
            whatsapp: 'WhatsApp',
            whatsappPlaceholder: 'Inserisci il tuo WhatsApp per poterti contattare',
            email: 'Email',
            emailPlaceholder: 'Inserisci la tua email per poterti contattare',
            remark: 'Note',
            remarkPlaceholder: 'Inserisci eventuali note per aiutarci a capire meglio le tue esigenze'
        },
        alert: {
            fillRequired: 'Compila tutti i campi obbligatori (contrassegnati con *)',
            submitSuccess: 'Richiesta inviata con successo! Il nostro team di vendita ti contatterà a breve.'
        }
    },
    contact: {
        hero: {
            title: 'Contattaci',
            desc: 'Ottieni consigli professionali e le soluzioni più adatte a te'
        },
        form: {
            title: 'Inviaci un messaggio',
            subtitle: 'Compila il modulo sottostante e ti ricontatteremo entro 24 ore.',
            firstName: 'Nome',
            firstNamePlaceholder: 'Es. Mario',
            lastName: 'Cognome',
            lastNamePlaceholder: 'Es. Rossi',
            email: 'Email di lavoro',
            emailPlaceholder: "mario{'@'}azienda.com",
            inquiryType: 'Tipo di richiesta',
            selectTopic: 'Seleziona un argomento...',
            message: 'Messaggio',
            messagePlaceholder: 'Come possiamo aiutarti?',
            submitBtn: 'Invia Messaggio',
            sending: 'Invio in corso...',
            successMsg: 'Grazie! Il tuo messaggio è stato inviato con successo.'
        },
        inquiry: {
            general: 'Domanda Generale',
            sales: 'Vendite e Distribuzione',
            support: 'Supporto Tecnico',
            hardware: 'OEM/ODM',
        },
        location: {
            title: 'Dove Siamo',
            officeName: 'Sede di Shenzhen',
            address: 'Stanza 603, Unità 1, Edificio 1, Kailifang Plaza, Via Lianrun, Comunità Taoyuan, Via Dalang, Distretto di Longhua, Shenzhen, Guangdong, Cina',
            phone: '+86 18926403313 Sig.ra Yuan'
        }
    },
    footer: {
        companyName: 'Shenzhen Golden Security Technology Co., Ltd.'
    }
}